import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';

export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;

export const rowData: Array<any> = [
  {
    fieldName: 'name',
    width: '25%',
  }, {
    fieldName: 'code',
    width: '25%',
    type: DetailsControlType.Select,
  }, {
    fieldName: 'reference',
    width: '25%',
    type: DetailsControlType.Select,
  }, {
    fieldName: 'valuesCount',
    width: '25%',
    disabled: true,
    title: 'Copies'
  },
];

export const contentData: Array<any> = [
  [{
    fieldName: 'digitalAssets',
    width: '100%',
    type: DetailsControlType.Asset,
  }],
  [{
    fieldName: 'type',
    width: '50%',
    type: DetailsControlType.Select,
  }],
  [{
    fieldName: 'value',
    width: '100%',
    type: DetailsControlType.Textarea,
  }]
];
